import script from "./LoadingView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingView.vue?vue&type=script&setup=true&lang=js"

import "./LoadingView.vue?vue&type=style&index=0&id=6acee613&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6acee613"]])

export default __exports__